import FilterList from '@/components/content/FilterList'
import Input from '@/components/content/Input'
import DateRangePickerInput from '@/components/date/DateRangePickerInput'
import MenuCodeSelectModal from '@/components/system/MenuCodeSelectModal'
import SearchInput from '@/components/system/SearchInput'
import { HistoryDownloadLogReqParams } from '@/services/history/history.types'
import { DATE_FORMAT } from '@/utils/consts'
import dayjs from 'dayjs'
import { useFormContext } from 'react-hook-form'

export const defaultValues: HistoryDownloadLogReqParams = {
  email: '',
  evtDate: [dayjs().format(DATE_FORMAT.dateSimple), dayjs().format(DATE_FORMAT.dateSimple)],
  menuCd: '',
}

interface DownloadLogFormProps {
  onSearch(values: HistoryDownloadLogReqParams): void
}
export const DownloadLogForm = ({ onSearch }: DownloadLogFormProps) => {
  const { setValue, watch, reset, handleSubmit } = useFormContext<HistoryDownloadLogReqParams>()
  const values = watch()

  return (
    <FilterList
      list={[
        [
          { label: '유저 ID', value: <Input value={values.email} onChange={(v) => setValue('email', v)} /> },
          {
            label: '사용일자',
            required: true,
            value: (
              <DateRangePickerInput
                value={values.evtDate}
                onChange={(v) => {
                  const [start, end] = v
                  setValue('evtDate', [
                    start ? dayjs(start).format(DATE_FORMAT.dateSimple) : '',
                    end ? dayjs(end).format(DATE_FORMAT.dateSimple) : '',
                  ])
                }}
              />
            ),
          },
          {
            label: '메뉴코드',
            value: (
              <MenuCodeSelectModal
                trigger={<SearchInput value={values.menuCd} onChange={(v) => setValue('menuCd', v)} />}
                onSelect={({ menuCode }) => setValue('menuCd', menuCode)}
              />
            ),
          },
        ],
      ]}
      onReset={() => reset(defaultValues)}
      onSearch={handleSubmit(onSearch)}
    />
  )
}
